// extracted by mini-css-extract-plugin
export default {"modalcontent":"Modal_modalcontent__VGIor","closebutton":"Modal_closebutton__m5JNw"};